<template>
    <div class="Map">

        <div class="left">
            <div class="line_map_title">{{ mapTitle }}</div>
            <template v-if="type != 'edit'">
                <div class="line_map_title line_map_content" v-for="item in oldValue" :key="item.id">{{ item.name }}
                </div>
            </template>
            <template v-else>
                <div>
                    <a-checkbox-group v-model:value="choosed" style="width: 100%" @change="roadsChange">
                        <div v-for="item in roadList" :key="item.id" style="width: 100%;"
                            class="line_map_title line_map_content">
                            <a-checkbox :value="item.id">{{ item.name }}</a-checkbox>
                        </div>
                    </a-checkbox-group>
                </div>
            </template>
        </div>
        <div class="right">
            <!-- Map -->
            <div id="map-container"> </div>
        </div>
        <!-- <div class="map-set">
            

        </div> -->
    </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, shallowRef, defineProps, watch, defineExpose } from 'vue'
import AMapLoader from '@amap/amap-jsapi-loader'

const props = defineProps({
    type: "",
    roadList: {
        type: Array,
        default: () => []
    },
    oldValue: {
        type: Array,
        default: () => []
    },
    carValue: {
        type: String,
        default: () => ' '
    },
    mapTitle: {
        type: String,
        default: () => ''
    }
})

const map = shallowRef(null)
let mapData = ref([])

let polylines = ref([])
let roads = ref([])
const choosed = ref([]);

watch(roads,
    (val) => {
        console.log(val, '2q3123123123123');

        if (map.value) {
            clearMap();
            set_map();
        } else {
            setTimeout(() => {
                clearMap();
                set_map();

            }, 1200);
        }
    }
)

// watch(props.roadList,
//     (val) => {
//         console.log(val, 'carValue');

//         if (map.value) {
//             clearMap();
//             set_map();
//         } else {
//             setTimeout(() => {
//                 clearMap();
//                 set_map();

//             }, 1200);
//         }
//     }, {
//     deep: true, immediate: true
// }
// )

watch(() => props.oldValue,
    (val) => {
        console.log(val, '555');
        mapData.value = val;
        if (map.value != null) {
            console.log(123123123);
            clearMap();
            set_map();
        } else {
            setTimeout(() => {
                clearMap();
                set_map();

            }, 1200);
        }
    }, {
    deep: true, immediate: true
}
)


const set_map = () => {
    if (map.value) {
        map.value && addPolylines()
    } else {
        setTimeout(() => {
            map.value && addPolylines()
        }, 1200);
    }
}


const drawMap = async () => {
    const AMap = await AMapLoader.load({
        key: '6588d9e5b6ae0751c799cb4c7b3e30be',
        version: '2.0',
        Loca: {
            // 是否加载 Loca， 缺省不加载
            version: '2.0.0' // Loca 版本，缺省 1.3.2
        },
        plugins: ['AMap.MouseTool', 'AMap.PolylineEditor', 'AMap.PolyEditor']
    })
    map.value = new AMap.Map('map-container', {
        zoom: 12,
        mapStyle: 'amap://styles/45311ae996a8bea0da10ad5151f72979',
        center: [103.726465, 36.107992]
    })
    map.value.setZooms([2, 30])
    // map.value.setLayers([])
}

// 画线
const addPolylines = () => {
    polylines.value = []
    // 添加线
    mapData.value.forEach(item => {
        // 画面
        if (item.locationInfo.type == 'polygon') {
            polylines.value.push(addDrawPolygon(item))
        } else {
            // 画圆
            // polylines.value.push(addDrawLines(item))
            polylines.value.push(addDrawCircle(item))
        }

    })
    console.log(polylines.value)
    map.value.add(polylines.value) // 动态添加数据
    map.value.setFitView();//让所有点都在可是区域内
}
const addDrawLines = (item) => {

    var polyline = new AMap.Polyline({
        path: item.locationInfo.coordinates,
        // cursor: 'pointer',
        // borderWeight: 30,
        // strokeColor: '#1E8EF2',
        // strokeOpacity: 1,
        // strokeWeight: 3,
        // // 折线样式还支持 'dashed'
        // strokeStyle: "dashed",
        // zIndex: 50,

        strokeColor: "blue",
        strokeWeight: 6,
        strokeOpacity: 0.9,
        zIndex: 50,
        bubble: true,
    })
    return polyline


}

const addDrawPolygon = (item) => {
    var Polygon = new AMap.Polygon({
        path: item.locationInfo.coordinates,
        zIndex: 50,
        bubble: true,
        strokeColor: "#F23218",
        strokeOpacity: 1,
        strokeWeight: 2,
        strokeOpacity: 0.7,
        fillColor: '#F2AA1E',
        fillOpacity: 0.4,
        // 线样式还支持 'dashed'
        strokeStyle: "solid",
        // strokeStyle是dashed时有效
        // strokeDasharray: [30,10],
    })
    return Polygon
}

const addDrawCircle = (item) => {
    var Circle = new AMap.Circle({
        center: item.locationInfo.coordinates,
        radius: item.locationInfo.radius, //半径
        borderWeight: 3,
        strokeColor: "#F23218",
        strokeOpacity: 1,
        strokeWeight: 2,
        strokeOpacity: 0.7,
        fillOpacity: 0.4,
        strokeStyle: 'solid',
        strokeDasharray: [10, 10],
        // 线样式还支持 'dashed'
        fillColor: '#F2AA1E',
        zIndex: 50,
    })
    return Circle
}


const roadsChange = (val) => {
    console.log(val);
    mapData.value = [];
    props.roadList.map(item => {
        if (val.includes(item.id)) {
            mapData.value.push(item)
        }
    })
    polylines.value = [];
    roads.value = val;
}


//清除地图;
const clearMap = () => {
    if (window.loca) {
        //清空所有图层，包括图层的光源
        window.loca.clear();
    }
    polylines.value && map.value.remove(polylines.value) // 清除所有的线
    map.value && map.value.clearMap();

}
//销毁地图
const destroyMap = () => {
    map.value && map.value.destroy();
    console.info("地图已销毁");
}

onMounted(async () => {
    await drawMap()
    // await addMarkers()
})

onBeforeMount(() => {
    // convertLightList()
    destroyMap()

})

defineExpose({
    choosed,
    clearMap,
    polylines
})



</script>
<style lang="less" scoped>
.Map {
    display: flex;

    .left {
        width: 17vw;
        padding: 18px 19px 0 17px;

        .line_map_title {
            padding: 10px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            color: #1D2129;
            border-top: 1px solid #E1E7EF;
            border-bottom: 1px solid #E1E7EF;
            background: #FFFFFF;
        }

        .line_map_content {
            border-top: none;
            color: #636D7B;
            padding: 12px 5px 15px 10px;
        }
    }

    .right {
        flex: 1;
        border: 1px solid #7CA6CE;
    }
}

#map-container {
    width: 100%;
    height: 495px;
}

/deep/ .amap-logo {
    display: none !important;
}

/deep/ .amap-copyright {
    opacity: 0 !important;
}
</style>
